export interface CookieRow {
  name: string;
  provider: string;
  lifetime: string;
  purpose: string;
}

export interface CookieCategory {
  key: "required" | "functional" | "advertising";
  title: string;
  description: string;
  cookies: CookieRow[];
}

// Inventory from the live-site audit in the FIV-499 spec (2026-07-20).
export const COOKIE_CATEGORIES: CookieCategory[] = [
  {
    key: "required",
    title: "Required Cookies",
    description:
      "These cookies are necessary to enable the basic features of this site to function, such as providing secure log-in, protecting our forms from abuse, or allowing you to select your cookie preferences.",
    cookies: [
      { name: "fs_cookie_consent", provider: "Fivestar", lifetime: "12 months", purpose: "Stores the cookie choices you make here" },
      { name: "__cf_bm", provider: "Vimeo / Cloudflare", lifetime: "30 minutes", purpose: "Bot protection for embedded video players" },
      { name: "Cloudflare Turnstile", provider: "Cloudflare", lifetime: "Session", purpose: "Protects our forms from automated abuse" },
      { name: "Supabase auth", provider: "Fivestar", lifetime: "Session", purpose: "Keeps you signed in (admin/portal log-in only)" },
    ],
  },
  {
    key: "functional",
    title: "Functional Cookies",
    description:
      "These cookies allow us to analyze your use of the site to evaluate and improve its performance. They help us understand how the site is used so we can provide a better customer experience.",
    cookies: [
      { name: "_ga / _ga_RZ6WEV9EYF", provider: "Google Analytics", lifetime: "13 months", purpose: "Distinguishes visitors and sessions for usage statistics" },
      { name: "_dd_s", provider: "Datadog", lifetime: "Session", purpose: "Performance monitoring and error diagnostics" },
      { name: "fs_visitor_id / fs_first_touch / fs_exp_state", provider: "Fivestar", lifetime: "Up to 12 months", purpose: "First-party usage measurement and A/B testing" },
    ],
  },
  {
    key: "advertising",
    title: "Advertising Cookies",
    description:
      "These cookies are used to make our outreach more relevant to you. We may share this information with partners to better understand the businesses visiting our site, keep track of when visitors return, or help make the content and offers you see more relevant.",
    cookies: [
      { name: "_zitok / visitorId", provider: "ZoomInfo", lifetime: "12 months", purpose: "Identifies your company for business-to-business outreach" },
      { name: "chs / cb", provider: "Clickagy", lifetime: "13 months", purpose: "Behavioral intent data and ad targeting" },
      { name: "IDE", provider: "Google DoubleClick", lifetime: "13 months", purpose: "Ad targeting (set via ZoomInfo's network)" },
      { name: "i", provider: "OpenX", lifetime: "12 months", purpose: "Ad-exchange visitor matching (set via ZoomInfo's network)" },
    ],
  },
];
